import { render, staticRenderFns } from "./FormCreationDialog.vue?vue&type=template&id=47932381&scoped=true"
import script from "./FormCreationDialog.vue?vue&type=script&lang=js"
export * from "./FormCreationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47932381",
  null
  
)

export default component.exports